import { MARQUEE_ITEMS } from "../lib/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="marquee-section" className="relative py-10 border-y border-amber-500/15 bg-[#0b0c10] overflow-hidden">
      <div className="marquee-track flex items-center gap-10 whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display italic text-2xl sm:text-3xl text-white/25">{item}</span>
            <span className="w-2 h-2 rounded-full bg-amber-500/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
